module.exports = __webpack_public_path__ + "static/media/OffPlanMeal.c09fc91e.jpg";